import type { ReactNode } from "react";

import { cssFns } from "../../css";
import { colors } from "../../theme";
import { BaseButton, type BaseButtonProps } from "../base-button";
import {
  createButtonStylesWaterfall,
  useButtonStylesWaterfall,
} from "../styles";

const buttonStyles = createButtonStylesWaterfall({
  idle: {
    common: [
      cssFns.padding(0, 10),
      cssFns.border({ radius: "4px", width: "0px" }),
      {
        color: colors.principal.white,
        backgroundColor: colors.principal.ebblue,
      },
    ],
    mobile: [
      cssFns.typo({ level: "body-1", weight: "semibold" }),
      { height: 32 },
    ],
    desktop: [
      cssFns.typo({ level: "body-2", weight: "semibold" }),
      { height: 24 },
    ],
  },
  hover: {
    backgroundColor: "#97BFDA",
  },
  disabled: {
    color: cssFns.setOpacity(colors.principal.white, 0.7),
    backgroundColor: "#D8DCDE",
  },
});

export const TimeSlotButton = ({
  text,
  icon,
  onIconPress,
  ...baseProps
}: {
  text: string;
  icon?: ReactNode;
  onIconPress?: () => void;
} & Pick<BaseButtonProps, "disabled" | "onPress">) => {
  const { waterfall } = useButtonStylesWaterfall(buttonStyles);

  return (
    <BaseButton type="button" waterfall={waterfall} {...baseProps}>
      {text}
      {icon && (
        <div
          css={{
            zIndex: 1,
            display: "flex",
          }}
          onClick={(e) => {
            if (onIconPress) {
              e.stopPropagation();
              onIconPress();
            }
          }}
        >
          {icon}
        </div>
      )}
    </BaseButton>
  );
};
